import {defineStore} from 'pinia'
import { type Ref, ref } from 'vue'
import type { DocumentVerification } from '~/libs/document-intelligence-types'

export const useDocumentIntelligenceStore = defineStore('documentIntelligence', () => {

  /*
   * STATE
  */
  const documentVerifications: Ref<DocumentVerification[]> = ref([])
  const documentVerificationsEnabled: Ref<boolean | null> = ref(null)
  const configPromise: Ref<Promise<boolean> | null> = ref(null)

  /*
   * GETTERS
  */

  /*
   * ACTIONS
  */
  function setDocumentVerifications(verifications: DocumentVerification[]) {
    documentVerifications.value = verifications
  }

  function upsertDocumentVerification(verification: DocumentVerification) {
    const existingIndex = documentVerifications.value.findIndex(v => v.documentId === verification.documentId)
    if (existingIndex !== -1) {
      documentVerifications.value[existingIndex] = verification
      return
    }

    documentVerifications.value.push(verification)
  }

  function setDocumentVerificationsEnabled(enabled = false) {
    documentVerificationsEnabled.value = enabled
  }

  function removeVerification(docId: number) {
    documentVerifications.value = documentVerifications.value.filter(verification => verification.documentId !== docId)
  }

  function setConfigPromise(promise: Promise<boolean> | null) {
    configPromise.value = promise
  }

  return {
    // STATE
    documentVerifications,
    documentVerificationsEnabled,
    configPromise,
    // GETTERS
    // ACTIONS
    setDocumentVerifications,
    upsertDocumentVerification,
    setDocumentVerificationsEnabled,
    removeVerification,
    setConfigPromise
  }
})
